import React from 'react'
import './header.css'
import LOGO1 from '../../assets/GXLogo3.png'

const data = [
  {
    avatar: LOGO1,
    name: 'GXBudz',
  },

]


const Header = () => {
  return (
    <header>
      <section id='home'></section>

      <div className="container headernav__container">
        <h5>Welcome to</h5>
          {
            data.map(({avatar, name}, index) => {
              return (
                <article key={index} className="headernavs">
                  <div className="headernav__avatar">
                    <img src={avatar} alt={name} />
                  </div>
                </article>
              )
            })
          }

        <h5 className="text-light">Set course for collective exploration.</h5>

          </div>
    </header>
  )
}

export default Header